export const elements = [
	{ link: '/stocks/s-in-the-hum', icon: 'sale', text: 'Выгодное предложение' },
	{ link: '/buyers/b-gift-certificate', icon: 'gift-card', text: 'Подарочный сертификат' },
	{ link: '/buyers/b-installment-plan-credit', icon: 'credit-card', text: 'Способы оплаты' },
	{ link: '/buyers/b-loyalty-program', icon: 'pay', text: 'Программа лояльности' },
	{ link: '/buyers/b-shipping', icon: 'delivery-truck', text: 'Удобная доставка' },
]
